import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../../../components/forms/index"
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import url from "../../../../config/axios";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const UsedItemsUpdate = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
    const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isloading, setIsloading] = useState(false);
  const { id } = useParams();
  const [shopCategoryone, setShopCategoryone] = useState();

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];
  localStorage.setItem('mycategory', categoryName);

  const onDrop = async (acceptedFiles) => {
    try {
        setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    shopCategory: categoryid,
    marketPlace: "",
    businessType: "usedShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setIsloading(true)
    url
      .get(`shop/id?id=${id}`)
      .then(async (response) => {
        if (response.data.success) {
          setIsloading(false)
          setCreateShop(response?.data?.data?.Shop);
        }
      })
      .catch((error) => {
        setIsloading(false)
        console.log("error", error);
      });
  }, []);
  useEffect(() => {
    url
      .get("category/type/?type=usedShop&parentCategory=")
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategoryone(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
      });
  }, []);

  const UpdateShop = (e) => {
    setIsloading(true)
    e.preventDefault();
    url
      .put(`shop/id?id=${id}`, createShop)
      .then(async (response) => {
        if (response?.data?.success) {
          setIsloading(false)
          setTimeout(() => {
            SuccessNotify("Form Update Successfully");
            navigate("/Used-Items-Bussines-Profile/" + id);
          }, 1000);
        }
      })
      .catch((error) => {
        setIsloading(false)
        FailedNotify("Failed to Update");
      });
  };
  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }
  return (
    <Form
      title="Fill to update Used Items Shop"
      butn="Update"
      navigateTo="/Used-Items-Bussines-Profile"
      back="/Used-Items-Bussines-Profile/"
      UpdateShop={UpdateShop}
      createShop={createShop}
      link="/used-items-update/"
      setCreateShop={setCreateShop}
      id={id}
      Shopdatas={Shopdatas}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      shopCategoryone={shopCategoryone}
      isUploading={isUploading}           
uploadProgress={uploadProgress} 
    />
  );
};
export default UsedItemsUpdate;
